import { TDropdownOption } from 'ui/shared/Dropdown/Select'

export const countryOptions: TDropdownOption[] = [
  { id: 0, value: 'null', label: '-' },
  { id: 1, value: 'de', label: 'Deutschland' },
  { id: 2, value: 'fr', label: 'Frankreich' },
  { id: 3, value: 'at', label: 'Österreich' },
]
